import { Helper } from '../../../../common/helpers/Helper'
import { UiHelper } from '../../../../common/helpers/UiHelper'

function asTagList(value) {
  if (Array.isArray(value)) {
    return value.map(v => String(v || '').trim()).filter(Boolean)
  }
  if (typeof value === 'string' && value.trim()) {
    return value.split(',').map(s => s.trim()).filter(Boolean)
  }
  return []
}

function uniqueTags(list) {
  const seen = {}
  const out = []
  for (let i = 0; i < list.length; i++) {
    const t = list[i]
    if (!t || seen[t]) continue
    seen[t] = true
    out.push(t)
  }
  return out
}

function hasFields(fieldDef) {
  return !!(fieldDef && fieldDef.steps && fieldDef.steps[0] && Array.isArray(fieldDef.steps[0].fields))
}

export function buildContactStateOptions(fieldDef, orgId) {
  if (!hasFields(fieldDef)) return []
  const stateField = Helper.getField(fieldDef, 'state')
  if (!stateField || !Array.isArray(stateField.options)) return []
  const field = JSON.parse(JSON.stringify(stateField))
  try {
    UiHelper.removeHiddenCrmContactStates(field, orgId)
  } catch (e) {
    field.options = field.options || []
  }
  UiHelper.renameLeadStatusFieldOptions(field, orgId)
  return (field.options || []).filter(o => o && o.key)
}

export function buildContactTagOptions(fieldDef, crmContactAttrs) {
  const dummy = {
    steps: [{
      fields: [{
        key: 'tags',
        options: [],
      }],
    }],
  }
  if (hasFields(fieldDef)) {
    const tagsField = Helper.getField(fieldDef, 'tags')
    if (tagsField && Array.isArray(tagsField.options) && tagsField.options.length) {
      dummy.steps[0].fields[0].options = tagsField.options.slice()
    }
  }
  const fromAttrs = Helper.extractAttrs(crmContactAttrs, 'tags')
  if (fromAttrs.length) {
    Helper.loadAttrOptions(dummy, crmContactAttrs, 'tags')
  }
  let options = dummy.steps[0].fields[0].options || []
  if (!Helper.isShowInternal()) {
    options = options.filter(o => o && o.key !== 'INTERNAL')
  }
  return options.sort((a, b) => String(a.label || a.key).localeCompare(String(b.label || b.key)))
}

export function patchContactFormOptions(fieldDef, stateOptions, tagOptions) {
  const fields = fieldDef && fieldDef.steps && fieldDef.steps[0] && fieldDef.steps[0].fields
  if (!Array.isArray(fields)) return false
  const states = Array.isArray(stateOptions) ? stateOptions : []
  const tags = Array.isArray(tagOptions) ? tagOptions : []
  let patched = false
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i]
    if (!field) continue
    if (field.key === 'state') {
      field.options = states
      patched = true
    } else if (field.key === 'tags' || field.key === 'tags!') {
      field.options = tags
      patched = true
    }
  }
  return patched
}

export function getChatbotContactFieldDef(stateOptions, tagOptions) {
  const states = Array.isArray(stateOptions) ? stateOptions : []
  const tags = Array.isArray(tagOptions) ? tagOptions : []
  return {
    title: 'Update Contact',
    formType: 'edit',
    ctaButtonText: 'Save',
    steps: [{
      fields: [
        {
          key: 'state',
          type: 'radio',
          label: 'Next Status',
          options: states,
          v_required: { value: false, err: '' },
          placement: 'left',
        },
        {
          key: 'tags',
          type: 'check_box',
          label: 'Add tags',
          tip: 'Added to the contact',
          options: tags,
          v_required: { value: false, err: '' },
          placement: 'left',
        },
        {
          key: 'tags!',
          type: 'check_box',
          label: 'Remove tags',
          tip: 'Taken off the contact',
          options: tags,
          v_required: { value: false, err: '' },
          placement: 'left',
        },
      ],
    }],
  }
}

export function contactNodeDataToFormItem(data) {
  const d = data || {}
  return {
    state: d.state || '',
    tags: asTagList(d.tags),
    'tags!': asTagList(d['tags!']),
  }
}

export function formDataToContactNodeData(formData) {
  const fd = formData || {}
  const out = {}
  const state = String(fd.state || '').trim()
  if (state) out.state = state
  const add = uniqueTags(asTagList(fd.tags))
  const addSet = {}
  for (let i = 0; i < add.length; i++) addSet[add[i]] = true
  const remove = uniqueTags(asTagList(fd['tags!'])).filter(t => !addSet[t])
  if (add.length) out.tags = add
  if (remove.length) out['tags!'] = remove
  return out
}
